module.exports = __webpack_public_path__ + "static/img/keep-bg.cef01a6f.png";